import { COLOR, FONT_SIZE, FONT_WEIGHT, LazyImage } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivWrapper = styled.div`
  display: flex;
  margin-left: 12px;
  cursor: default;
`;

export const ImageIcon = styled(LazyImage)`
  margin-right: 4px;
  img {
    background: none;
  }
  > picture {
    background: none;
  }
`;

export const SpanTitle = styled.a`
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  color: ${COLOR.GRAY900};
  text-align: center;
  padding: 3px;
`;
